import { getOutlineStyle } from './input';
const size = {
    xl: {
        fontSize: 'lg',
        paddingX: 3,
        h: '3rem',
        borderRadius: 'base',
    },
    lg: {
        fontSize: 'lg',
        paddingX: 3,
        h: '2.625rem',
        borderRadius: 'base',
    },
    md: {
        fontSize: 'lg',
        paddingX: 3,
        h: '2.25rem',
        borderRadius: 'base',
    },
    sm: {
        fontSize: 'md',
        paddingX: 3,
        height: '1.875rem',
        borderRadius: 'base',
    },
};
const sizes = {
    xl: {
        field: size.xl,
        addon: size.xl,
    },
    lg: {
        field: size.lg,
        addon: size.lg,
    },
    md: {
        field: size.md,
        addon: size.md,
    },
    sm: {
        field: size.sm,
        addon: size.sm,
    },
};
const variants = {
    outline: getOutlineStyle,
};
export default {
    sizes,
    variants,
};
//# sourceMappingURL=select.js.map